import React from 'react';

import { Container, Content, ContentButton, Form } from './style';

import { BaSeButton } from '@base/react';
import { useUfController } from '../../../../hooks/controllers/uf-controller';
import { FormContext } from '../../hook/form-context';
import { useDisplay } from '../../hook/useDisplay';
import SelectEmpretecMobile from './select-empretec-mobile';
import SelectEmpretecWeb from './select-empretec-web';

function Subscription() {
  const { getUfs } = useUfController();
  const { isLargeDisplay } = useDisplay();

  const {
    setListUf,
    handleCreateInterview,
    empretecId,
    acept,
    showPersonalDataForm,
  } = React.useContext(FormContext);

  const mapNameButton = {
    1: 'Registrar interesse e seguir para entrevista',
    2: 'Registrar interesse e iniciar autoavaliação',
    3: 'Registrar interesse e seguir para entrevista',
    4: 'Registrar interesse',
  };

  React.useEffect(() => {
    getUfs()
      .then((response) => {
        response.unshift({
          id: 0,
          label: 'Selecione',
          sigla: 'Selecione',
        });
        setListUf(response);
      })
      .catch(() => setListUf([]));
  }, [getUfs, setListUf]);

  const handleMenuClick = React.useCallback(() => {
    const section = document.getElementById('2');
    const offset = 94;
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, []);

  return (
    <Container id="7">
      <Content>
        <Form>
          {isLargeDisplay() ? (
            <SelectEmpretecWeb handleMenuClick={handleMenuClick} />
          ) : (
            <SelectEmpretecMobile handleMenuClick={handleMenuClick} />
          )}
          <ContentButton
          >
            {isLargeDisplay() && acept && showPersonalDataForm && (
              <BaSeButton
                borderRadius="max"
                buttonType="submit"
                overrideColors={{
                  backgroundColor: '#fff',
                  foreground: '#0000C9',
                  borderColor: '#fff',
                }}
                leftIcon=""
                onClick={() => handleCreateInterview()}
                loadingText="Carregando…"
                size="medium"
                isBold
                type="secondary"
                value={mapNameButton[empretecId]}
              />
            )}
          </ContentButton>
        </Form>
      </Content>
    </Container>
  );
}

export default Subscription;
